const availablePaymentEngines = {
  openPay: 'open_pay',
  adyen: 'adyen',
  mercadoPago: 'mercadopago',
  cybersource: 'cybersource',
  yape: 'yape',
  kueskiPay: 'kueski_pay',
  cielo: 'cielo',
  rede: 'rede',
  stripe: 'stripe',
};

export default availablePaymentEngines;
